import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function RawStock() {
  const { user } = useAuth();
  const [materials, setMaterials] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ code: '', name: '', unit: 'kg', category: 'raw_material', min_qty: 0 });
  const [msg, setMsg] = useState('');

  const load = () => axios.get('/api/materials').then(r => setMaterials(r.data));
  useEffect(() => { load(); }, []);

  const handleSubmit = async () => {
    try {
      await axios.post('/api/materials', form);
      setMsg('เพิ่มวัตถุดิบสำเร็จ');
      setShowForm(false);
      setForm({ code: '', name: '', unit: 'kg', category: 'raw_material', min_qty: 0 });
      load();
      setTimeout(() => setMsg(''), 3000);
    } catch (err) {
      setMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด');
    }
  };

  return (
    <div>
      {msg && <div className={`alert ${msg.includes('สำเร็จ') ? 'alert-success' : 'alert-danger'}`}>{msg}</div>}

      <div className="sh">วัตถุดิบและบรรจุภัณฑ์</div>
      <div className="glass-card">
        <table className="tbl">
          <thead>
            <tr>
              <th>รหัส</th><th>ชื่อ</th><th>หมวด</th><th>หน่วย</th>
              <th>สต็อก</th><th>Min</th>
              {user?.can_see_cost && <th>Avg Cost</th>}
              <th>สถานะ</th>
            </tr>
          </thead>
          <tbody>
            {materials.map(m => (
              <tr key={m.id}>
                <td style={{ fontFamily: 'monospace', fontSize: 11, color: 'var(--text-muted)' }}>{m.code}</td>
                <td style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{m.name}</td>
                <td><span className={`badge ${m.category === 'raw_material' ? 'badge-blue' : 'badge-purple'}`}>{m.category === 'raw_material' ? 'วัตถุดิบ' : 'บรรจุภัณฑ์'}</span></td>
                <td>{m.unit}</td>
                <td style={{ fontWeight: 600, color: m.is_low ? 'var(--warning)' : 'var(--text-primary)' }}>{parseFloat(m.stock_qty).toFixed(4)}</td>
                <td>{parseFloat(m.min_qty).toFixed(2)}</td>
                {user?.can_see_cost && <td>฿{parseFloat(m.avg_cost || 0).toFixed(4)}</td>}
                <td><span className={`badge ${m.is_low ? 'badge-warn' : 'badge-ok'}`}>{m.is_low ? 'ต่ำกว่า min' : 'ปกติ'}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="btn-row">
          <button className="btn-primary" onClick={() => setShowForm(!showForm)}>+ เพิ่มวัตถุดิบ</button>
        </div>
      </div>

      {showForm && (
        <>
          <div className="sh">เพิ่มวัตถุดิบใหม่</div>
          <div className="glass-card">
            <div className="grid-2">
              <div className="form-group"><label className="fl">รหัส</label><input className="fi" value={form.code} onChange={e => setForm(f=>({...f,code:e.target.value}))} placeholder="RM-001"/></div>
              <div className="form-group"><label className="fl">ชื่อ</label><input className="fi" value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))} placeholder="ชื่อวัตถุดิบ"/></div>
              <div className="form-group"><label className="fl">หมวด</label>
                <select className="fi" value={form.category} onChange={e => setForm(f=>({...f,category:e.target.value}))}>
                  <option value="raw_material">วัตถุดิบ</option>
                  <option value="packaging">บรรจุภัณฑ์/ขวด</option>
                </select>
              </div>
              <div className="form-group"><label className="fl">หน่วย</label><input className="fi" value={form.unit} onChange={e => setForm(f=>({...f,unit:e.target.value}))} placeholder="kg, ขวด"/></div>
              <div className="form-group"><label className="fl">Stock ขั้นต่ำ</label><input className="fi" type="number" value={form.min_qty} onChange={e => setForm(f=>({...f,min_qty:e.target.value}))}/></div>
            </div>
            <div className="btn-row">
              <button className="btn-secondary" onClick={() => setShowForm(false)}>ยกเลิก</button>
              <button className="btn-primary" onClick={handleSubmit}>บันทึก</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
